import { UploadFile } from "antd";
import {
  AddProctorI,
  AllInfoForProctorI,
  PaginateProctor,
  PaginateProctorAllRecords,
  ProctorSelectedI,
} from "../interfaces/proctors.interface";
import http from "./axios";
import {
  addFilesToBody,
  convertObjectToFormData,
  downloadFile,
  handleError,
} from "./http-utils.service";

type ProctorSelectedResponse = {
  success: boolean;
  data: {
    user: ProctorSelectedI;
  };
};

export const getProctorsSelectedList = async (props: PaginateProctor) => {
  const { assignmentId, courseId, limit, skip, query } = props;
  const options = {
    params: {
      limit,
      skip,
      ...(query ? { search: query } : {}),
    },
  };
  const response = await http.get<{
    count: number;
    list: ProctorSelectedI[];
  }>(
    `/assignments/${assignmentId}/proctor-applications?courseId=${courseId}`,
    options,
  );
  return response.data;
};

export const addNewProctor = async (
  props: AddProctorI | { staffId: number },
) => {
  const response = await http.post<{
    success: boolean;
    data: ProctorSelectedI;
  }>(`/proctor-selected`, props);
  return response.data;
};

export const deleteProctor = async (proctorId: number) => {
  const response = await http.delete<{
    success: boolean;
    data: ProctorSelectedI;
  }>(`/proctor-selected/${proctorId}`);
  return response.data;
};

export const getProctorsfullRecords = async (
  props: PaginateProctorAllRecords,
) => {
  const { staffId, limit, skip, query } = props;
  const options = {
    params: {
      limit,
      skip,
      ...(query ? { search: query } : {}),
    },
  };
  const response = await http.get<{
    count: number;
    list: AllInfoForProctorI[];
  }>(`/proctor-selected/records?staffId=${staffId}`, options);
  return response.data;
};

export const updateProctorSelected = async (props: {
  data: Partial<ProctorSelectedI>;
  fileList: UploadFile[];
}): Promise<ProctorSelectedI> => {
  const formData = convertObjectToFormData(props.data);
  addFilesToBody(formData, props.fileList);
  const response = await http.patch<ProctorSelectedResponse>(
    `/proctor-selected/${props.data.id}`,
    formData,
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    },
  );
  return response.data.data.user;
};

export const proctorConfirmation = async (props: {
  proctorSelectedId: number;
  proctorAccepted: string;
}): Promise<ProctorSelectedI> => {
  const response = await http.post<ProctorSelectedI>(
    `proctor-selected/${props.proctorSelectedId}/proctor-confirmation`,
    props,
  );
  return response.data;
};

export const proctorConfirmationByStaff = async (
  props: Partial<ProctorSelectedI>,
): Promise<ProctorSelectedI> => {
  const response = await http.post<ProctorSelectedResponse>(
    `/proctor-selected/${props.id}/instructor-confirmation`,
    props,
  );
  return response.data.data.user;
};

export const confirmAllProctors = async (props: {
  assignmentId: number;
  proctorAccepted: "yes" | "no";
}): Promise<ProctorSelectedI> => {
  const response = await http.post<ProctorSelectedResponse>(
    `/assignments/${props.assignmentId}/confirm-all-proctor`,
    props,
  );
  return response.data.data.user;
};

export const downloadProctorSelectedExam = async (id: number, name: string) => {
  if (name === "") return false;

  try {
    const response = await http.get<{ url: string }>(
      `/proctor-selected/${id}/download`,
      {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
        },
      },
    );
    const res = await http.get<Blob>(response.data.url, {
      responseType: "blob",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
    });

    downloadFile(res.data, name);
    return res.data;
  } catch (e) {
    throw handleError(e);
  }
};
export const deleteProctorSelectedFile = async (id: number) => {
  const response = await http.delete<{
    success: boolean;
  }>(`/proctor-selected/${id}/file`);
  return response.data;
};
